import { createFileRoute, redirect } from "@tanstack/react-router";
import { WelcomePage } from "@/features/welcome/welcome-page";
import { probeSession } from "@/hooks/data";

const TITLE = "Malfak · AI social media management for Instagram, in Arabic and English";
const DESCRIPTION =
  "One inbox for Instagram comments and DMs, AI replies with human approval, automation rules, a Copilot, live dashboards and calendar intelligence. Arabic first, RTL native.";

/**
 * Public welcome page (ALP-85). Visitors see the product story with Log in / Sign up; a signed-in user goes straight to
 * their home (/home). The session check is bounded so a slow API never holds the page back.
 */
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const me = await Promise.race([
      probeSession(context.queryClient).catch(() => null), // QA F10: no 401 probe
      new Promise<null>((r) => setTimeout(() => r(null), 2500)),
    ]);
    if (me) throw redirect({ to: "/home" });
  },
  // OpenGraph/Twitter cards are static in index.html (link previews don't run the app); the route sets title + description
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
    ],
  }),
  component: WelcomePage,
});
